import type { FaireProductEntity } from "../../entity_types/product";

export const p_n6swtztaac: FaireProductEntity = {
  token: "p_n6swtztaac",
  type: "product",
  name: "Slim Fit Solid Color Blazer with Belt",
  brandToken: "b_999ccmmbkw",
  brandName: "Halcyon Outfitters®",
  imageUrl:
    "https://cdn.faire.com/fastly/8a70094dbd0782334241e4965ae7546cbc55048e22d1c0f1359e95943a3a023e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da854fa5082db5843a910b3b0bc9eab923f19373e0c1e0923d8c2c5910a56ee6.jpeg",
    "https://cdn.faire.com/fastly/476fc75f6cdc4120dfc03569d97693d308cb33e6c6f0269b906254f56975dbae.jpeg",
    "https://cdn.faire.com/fastly/9c29505da59d1014187811af358285f41ec327b88c43cb93a4daf3f6576247ae.jpeg",
    "https://cdn.faire.com/fastly/a9e538867a9e6a8f3b80d920e91a8cc9b30dc4513a5d26f3e547e5f65545afdb.jpeg",
    "https://cdn.faire.com/fastly/82fbfa2ef07c957c865d1d5e3fa648368f77e74b312381f4fd515556ac42a2e6.jpeg",
    "https://cdn.faire.com/fastly/301e67d3351a90e85e6c264bce5cb99e369635321efa51f7a8dffb4c4dfffa95.jpeg",
    "https://cdn.faire.com/fastly/34761f91a05c299c5f5aaa14b09276601e5c111db98294e6eab2fc8d10bbe70d.jpeg",
    "https://cdn.faire.com/fastly/15f0d92d74044a4974f95f9ad02debf8ee098b743a91552fc2c6856e7b4ab216.jpeg",
  ],
  priceDollars: 22,
  description:
    "Introducing our stylish and versatile slim fit blazer designed for the modern professional. Made from high-quality polyester, this blazer features a tailored silhouette with a classic lapel collar and long sleeves, making it perfect for commuting and casual outings.\n\nProduct Features:\n\n * Material: Durable polyester with wrinkle-free treatment for easy care \n * Fit: Slim fit, recommended to size up for a relaxed fit \n * Pattern: Solid color, available in multiple colors \n * Style: Elegant and trendy, ideal for office and casual wear \n * Length: Regular (50cm) \n * Closure: Belted for a chic look \n * Care: Machine washable for convenience \nThis blazer is available in a variety of colors, ensuring you find the perfect match for any outfit. Elevate your wardrobe with this essential piece that combines comfort and style effortlessly.\n",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:22.478Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
